import { Route } from '@angular/router';
import { PublicComponent } from './public.component';

export const publicRoutes: Route[] = [
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        loadComponent: () => import('./login/login').then(m => m.Login),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
];
